import '/home/runner/work/dialog/dialog/docs/demo/pure.md?watch=parent';
export const toc = new Proxy([], {});
export const frontmatter = new Proxy({"title":"pure-debug","toc":"menu","filename":"docs/demo/pure.md","lastUpdated":1785141763000,"nav":{"title":"Demo","path":"/demo"}}, {});

export const demoIndex = {
  ids: ["docs-demo-pure-demo-pure"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/pure.md?type=demo')
};